import store from '../util/store';

const MIN_WIDTH = 768;

export default class Columns {
  constructor($element) {
    this.$element = $element;
    this.resize();
  }

  reset() {
    var elementsToChange = this.$element.querySelectorAll(
      '[data-match-height]'
      ),
      elementsLength = elementsToChange.length;

    for (var i = 0; i < elementsLength; i++) {
      var item = elementsToChange[i];
      item.style.minHeight = null;
      item.style.height = null;
    }
  }

  resize() {
    if (store.windowWidth < MIN_WIDTH) {
      this.reset();
      return;
    }
    var groupName = Array.prototype.slice.call(
      this.$element.querySelectorAll('.js-column[data-match-height]')
      ),
      groupNameLength = groupName.length,
      groupHeights = {};

    for (var i = 0; i < groupNameLength ; i++) {
      var item = groupName[i];
      var data = item.getAttribute('data-match-height');

      item.style.minHeight = 'auto';
      item.style.height = 'auto';

      if (groupHeights.hasOwnProperty(data)) {
        Object.defineProperty(groupHeights, data, {
          value: Math.max(groupHeights[data], item.offsetHeight),
          configurable: true,
          writable: true,
          enumerable: true,
        });
      } else {
        groupHeights[data] = item.offsetHeight;
      }
    }

    var groupHeightsMax = groupHeights;

    var _this = this;
    Object.getOwnPropertyNames(groupHeightsMax).forEach(function(value) {
      var elementsToChange = _this.$element.querySelectorAll(
        '[data-match-height="' + value + '"]'
        ),
        elementsLength = elementsToChange.length;

      for (var i = 0; i < elementsLength; i++) {
        var item = elementsToChange[i];
        item.style.height = Object.getOwnPropertyDescriptor(groupHeightsMax, value).value + 'px';
      }
    });
  }

}



// WEBPACK FOOTER //
// ./scripts/dom/Columns.js